export default "__VITE_ASSET__D1LPV31y__"